// src/hooks/useRemix.js
import { useState } from 'react'
import { remixChat } from '../services/chatApi.js'

export default function useRemix() {
  const [loading, setLoading] = useState(false)
  const [error, setError]     = useState(null)

  /**
   * Create a remix of originalChatId, copying only the specified version.
   * @param {string} originalChatId
   * @param {number|null} versionIndex - index of the version to copy
   * @returns {Promise<string>} newChatId
   */
  async function remix(originalChatId, versionIndex = null) {
    setLoading(true)
    setError(null)
    try {
      const { newChatId } = await remixChat(originalChatId, versionIndex)
      return newChatId
    } catch (e) {
      setError(e)
      console.error('Remix failed', e)
      throw e
    } finally {
      setLoading(false)
    }
  }

  return { remix, loading, error }
}